<template>
  <div>
    <ModuleHome moduleName="Financials"/>
  </div>
</template>

<script>
import ModuleHome from '@/components/ModuleHome.vue';

export default {
  components: {
    ModuleHome
  },
  props: {},
  methods: {}
};
</script>

<style lang="scss" scoped>

</style>